import { FaInstagram, FaGlobe, FaWhatsapp } from "react-icons/fa";

import whatsappBg from "../image/BOTÃO_WHATS_DESKTOP_POWPIX.jpg";
import siteBg from "../image/BOTÃO_MEU_SITE_DESKTOP_POWPIX.jpg";
import instagramBg from "../image/BOTÃO_INSTAGRAM_DESKTOP_POWPIX.jpg";
import reclameAqui from "../image/BOTÃO_RECLAME_AQUI_DESKTOP_POWPIX.jpg";

export const links = [
  {
    label: "WhatsApp",
    url: "https://api.whatsapp.com/send/?phone=5579999928569&text=Estou+a+disposi%C3%A7%C3%A3o%21&type=phone_number&app_absent=0",
    target: "_blank",
    rel: "noopener noreferrer",
    urlIcon: FaWhatsapp,
    backgroundImage: whatsappBg,
  },
  {
    label: "Meu Site",
    url: "https://powpix.com.br/",
    target: "_blank",
    rel: "noopener noreferrer",
    urlIcon: FaGlobe,
    backgroundImage: siteBg,
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/usepowpix/",
    target: "_blank",
    rel: "noopener noreferrer",
    urlIcon: FaInstagram,
    backgroundImage: instagramBg,
  },
  {
    label: "Reclame Aqui",
    url: "https://www.reclameaqui.com.br/empresa/powpay-maquininhas-ltda/",
    target: "_blank",
    rel: "noopener noreferrer",
    backgroundImage: reclameAqui,
  },
  // {
  //   label: "Instagram",
  //   url: "https://www.instagram.com/usepowpix/",
  //   target: "_blank",
  //   rel: "noopener noreferrer",
  //   urlIcon: FaInstagram,
  //   backgroundImage: instagramBg,
  // },
];

// export const links = [
//   {
//     label: "WhatsApp",
//     url: "https://wa.me/seunumero",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaWhatsapp,
//     backgroundImage: "https://exemplo.com/whatsapp-bg.jpg",
//   },
//   {
//     label: "Meu Site",
//     url: "https://seudominio.com",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaYoutube,
//     backgroundImage: "https://exemplo.com/youtube-bg.jpg",
//   },
//   {
//     label: "Instagram",
//     url: "https://instagram.com/seuperfil",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaInstagram,
//     backgroundImage: "https://exemplo.com/instagram-bg.jpg",
//   },
// ];

// export const links = [
//   {
//     label: "WhatsApp",
//     url: "https://wa.me/seunumero",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaWhatsapp,
//     backgroundImage: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)", // Verde WhatsApp
//   },
//   {
//     label: "Meu Site",
//     url: "https://seudominio.com",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaYoutube,
//     backgroundImage: "linear-gradient(135deg, #FF0000 0%, #CC0000 100%)", // Vermelho YouTube
//   },
//   {
//     label: "Instagram",
//     url: "https://instagram.com/seuperfil",
//     target: "_blank",
//     rel: "noopener noreferrer",
//     urlIcon: FaInstagram,
//     backgroundImage:
//       "linear-gradient(135deg, #E4405F 0%, #C13584 50%, #833AB4 100%)", // Gradiente Instagram
//   },
// ];
